module.exports = __webpack_public_path__ + "img/ladderman.a39e57bc.svg";